module.exports = __webpack_public_path__ + "static/be-img-7ecc81daec1c9be003eb894c97565919.jpg";